import useErrors from '@/shared/context/errors-context';
import {
	TextField as MuiTextField,
	FilledTextFieldProps as MuiFilledTextFieldProps,
} from '@mui/material';
import { FunctionComponent, ReactElement } from 'react';
import FormInputErrors from './errors/FormInputErrors';

export type TextFieldProps = {
	formKey: string;
	name: string;
	clientErrors?: string | string[];
} & Omit<MuiFilledTextFieldProps, 'variant' | 'error' | 'helperText' | 'InputLabelProps'>;

const TextField: FunctionComponent<TextFieldProps> = ({
	formKey,
	name,
	clientErrors,
	...rest
}): ReactElement => {
	const apiErrors = useErrors().get(formKey)?.[`${name}`];

	return (
		<MuiTextField
			variant="filled"
			InputLabelProps={{ required: false }}
			error={!!(clientErrors || apiErrors)}
			helperText={<FormInputErrors errors={clientErrors || apiErrors} />}
			{...rest}
		/>
	);
};

export default TextField;
